import React, { Component } from 'react';
import { Container, Row, Col, Button, Label } from 'reactstrap';
import { withStyles, Card } from '@material-ui/core';
import * as Constants from '../Pages/Constants';
import {FormattedMessage} from 'react-intl';

class ValidationPopup extends Component{

    generate_buttons(message) {
        switch (message) {
            //Before sending the request
            case "Do you want to apply these changes":
                return (
                    <center>
                        <Button onClick={this.props.cancelPopup} outline color="danger" style={{ marginTop: "0.2em", width: "6em"}}><FormattedMessage id="button.cancel" defaultMessage="Cancel"/></Button>
                        <b>&emsp;</b> 
                        <Button onClick={this.props.validate} outline color="success" style={{ marginTop: "0.2em", width: "6em"}}><FormattedMessage id="button.validate" defaultMessage="Continue"/></Button>
                    </center>
                )
                break;
            //Success
            case "Success: These changes will be effective in a few minutes.":
                return (
                    <center>
                        <Button onClick={this.props.cancelPopup} outline color="success" style={{ marginTop: "0.2em", width: "6em"}}><FormattedMessage id="button.validate" defaultMessage="Continue"/></Button>
                    </center>
                )
                break;
            //Error
            default:
                return (
                    <center>
                        <Button onClick={this.props.cancelPopup} outline color="danger" style={{ marginTop: "0.2em", width: "6em"}}><FormattedMessage id="button.cancel" defaultMessage="Cancel"/></Button>
                    </center>
                )
                break;
        }
    }

    /**Return invalid email information popup*/
    render(){
        const { classes, message } = this.props;
    	return(
    		<div className={classes.popup_background}>
                <Container style={{ height: "100%", width: "100%" }} fluid>
                    <Row style={{ height: "100%", width: "100%" }}>
                        <Col xs="1" md="3" lg="4"></Col>
                        <Col xs="10" md="6" lg="4" style={{ height: "100%", display: "grid", placeItems: "center" }}>
                            <Card className={classes.popup} style={{ height: "90%", maxHeight: "11em", width: "100%", maxWidth: "30em", overflowY: "auto", placeItems: "center"  }}>
                               	<br/>
                               	<Row>
                                    <Label style={{fontWeight: "bold", textAlign: "center" }}>{message}</Label>
                               	</Row>
                               	<br/>
                                <Row style={{ flex: "0 1 auto" }}>
                                    {(this.props.message.props.defaultMessage !== "Success: These changes will be effective in a few minutes.") ?
                                        <center>
                                            <Button onClick={this.props.cancelPopup} outline color="danger" style={{ marginTop: "0.2em", width: "6em"}}><FormattedMessage id="button.cancel" defaultMessage="Cancel"/></Button>
                                            <b>&emsp;</b> 
                                            <Button onClick={this.props.validate} outline color="success" style={{ marginTop: "0.2em", width: "6em"}}><FormattedMessage id="button.validate" defaultMessage="Continue"/></Button>
                                        </center>
                                        :
                                        <center>
                                            <Button onClick={this.props.cancelPopup} outline color="success" style={{ marginTop: "0.2em", width: "6em"}}><FormattedMessage id="button.validate" defaultMessage="Continue"/></Button>
                                        </center>
                                    }
                                </Row>
                            </Card>
                        </Col>
                        <Col xs="1" md="3" lg="4"></Col>
                    </Row>
                </Container>
            </div>
    	);
    }
}
export default withStyles(Constants.styles)(ValidationPopup);